import { render, staticRenderFns } from "./StylesInspectorView.vue?vue&type=template&id=f9b59968&"
import script from "./StylesInspectorView.vue?vue&type=script&lang=js&"
export * from "./StylesInspectorView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports